import { Component, ElementRef, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { fadeInUpAnimation } from 'src/@fury/animations/fade-in-up.animation';
import { fadeInRightAnimation } from 'src/@fury/animations/fade-in-right.animation';
import { scaleInAnimation } from 'src/@fury/animations/scale-in.animation';
import { ENTER, COMMA } from '@angular/cdk/keycodes';
import { Observable, Subject } from 'rxjs';
import { ApiService } from 'src/app/services/api.service';
import { ErrorText } from 'src/app/enums/error-text.enum';
import { ErrorType } from 'src/app/enums/error-type.enum';
import { MatChipInputEvent } from '@angular/material/chips';
import {Location} from '@angular/common';
import { takeUntil } from 'rxjs/operators';
import { HttpErrorResponse, HttpResponse } from '@angular/common/http';
import endpoints from 'src/app/helpers/endpoints';

@Component({
  selector: 'fury-covered-item-add-edit',
  templateUrl: './covered-item-add-edit.component.html',
  styleUrls: ['./covered-item-add-edit.component.scss'],
  animations: [fadeInUpAnimation, fadeInRightAnimation, scaleInAnimation],
})
export class CoveredItemAddEditComponent implements OnInit, OnDestroy {

  coveredItemForm!: FormGroup;
  imagestoupload: any;
  visible = true;
  separatorKeysCodes: number[] = [ENTER, COMMA];
  itemfruitCtrl = new FormControl();
  filteredFruits!: Observable<string[]>;
  valuebucket: any;
  coveragehighlights: any;
  coveredItemId!: string;
  planOptionalItemCategories = [];
  ngUnsubscribe = new Subject<void>();
  isSelectedOptionalItem = false;
  optionalItem: any[] = [];

  constructor(
    private apiservice: ApiService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private el: ElementRef,
    public location: Location
  ) { }

  ngOnInit() {
    this.formInit();
    this.getMainFourPlanOptionalItem();
    this.getAllOptionalItemCategories();
    this.activatedRoute.params.pipe(takeUntil(this.ngUnsubscribe)).subscribe((res: any) => {
      if (res?.id) {
        this.coveredItemId = res.id;
      }
    });
  }

  getCoveredItemDetails(coveredItemId: string) {
    this.apiservice.get(endpoints.planManagement.coverItem.getCoverItem(coveredItemId)).pipe(takeUntil(this.ngUnsubscribe)).subscribe((res: any) => {
      if (res.body) {
        const {
          title,
          description,
          whatWeCover,
          notCovered,
          additionalInformation,
          maximumCoverage,
          freonCoverage,
          additionalInformationForNotCovered,
          additionalInformationForWhatWeCover,
          customPrice,
          standardPrice,
          averageCostForRepair,
          averageCostForReplacement,
          itemRemovalPrice,
          maximumCoverageIncreaseFee,
          maximumCoverageDecreaseFee,
          maximumAllowedDecrease,
          maximumAllowedIncrease,
          itemType,
          isActive,
          coverageHighlights,
          typeOfSystemWeCover,
          followingSystemTypesNotCovered,
          image,
          isClaim,
          forPopup,
          planType,
          allowedMultipleItem,
          coveredPlanIds,
          visibleToFrontend
        } = res.body.planCoverItem;
        this.coveredItemForm.patchValue({
          title,
          description,
          whatWeCover,
          notCovered,
          additionalInformation,
          maximumCoverage,
          freonCoverage,
          additionalInformationForNotCovered,
          additionalInformationForWhatWeCover,
          customPrice,
          standardPrice,
          averageCostForRepair,
          averageCostForReplacement,
          itemRemovalPrice,
          maximumCoverageIncreaseFee,
          maximumCoverageDecreaseFee,
          maximumAllowedDecrease,
          maximumAllowedIncrease,
          itemType,
          isActive,
          coverageHighlights: coverageHighlights ? coverageHighlights.split(',') : [],
          typeOfSystemWeCover: typeOfSystemWeCover ? typeOfSystemWeCover.split(',') : [],
          followingSystemTypesNotCovered: followingSystemTypesNotCovered ? followingSystemTypesNotCovered.split(',') : [],
          isClaim,
          forPopup,
          planType,
          allowedMultipleItem,
          coveredPlanIds,
          visibleToFrontend
        });
        this.imagestoupload = image;
      }
    }, err => {
      this.apiservice.alert(err.error.message, ErrorType.Error);
      this.location.back();
    });
  }

  formInit() {
    this.coveredItemForm = new FormGroup({
      title: new FormControl('', [Validators.required]),
      image: new FormControl(''),
      description: new FormControl('', Validators.required),
      coverageHighlights: new FormControl([]),
      typeOfSystemWeCover: new FormControl([]),
      whatWeCover: new FormControl('', Validators.required),
      notCovered: new FormControl(''),
      additionalInformation: new FormControl(''),
      followingSystemTypesNotCovered: new FormControl([]),
      maximumCoverage: new FormControl(''),
      freonCoverage: new FormControl(''),
      additionalInformationForNotCovered: new FormControl(''),
      additionalInformationForWhatWeCover: new FormControl(''),
      customPrice: new FormControl(''),
      standardPrice: new FormControl(''),
      averageCostForRepair: new FormControl(''),
      averageCostForReplacement: new FormControl(''),
      itemRemovalPrice: new FormControl(''),
      maximumCoverageIncreaseFee: new FormControl('', [Validators.min(0), Validators.max(100)]),
      maximumCoverageDecreaseFee: new FormControl('', [Validators.min(0), Validators.max(100)]),
      maximumAllowedDecrease: new FormControl(''),
      maximumAllowedIncrease: new FormControl(''),
      itemType: new FormControl('', Validators.required),
      isActive: new FormControl(true),
      isClaim: new FormControl(false),
      forPopup: new FormControl(false),
      planType: new FormControl('', [Validators.required]),
      allowedMultipleItem: new FormControl(true),
      coveredPlanIds: new FormControl(''),
      visibleToFrontend: new FormControl(true),
    });
  }

  addChip(event: MatChipInputEvent, controlName: string) {
    if(event.value.trim().length > 0) {      
    if (!this.coveredItemForm.value[controlName].some((x: any) => x === event.value)) {
      this.coveredItemForm.controls[controlName].patchValue(
        [...[event.value], ...this.coveredItemForm.value[controlName]]
      )
    }
    event.input.value = '';
  }
  }

  removeChip(event: string, controlName: string) {
    this.coveredItemForm.controls[controlName].patchValue(
      this.coveredItemForm.value[controlName].filter((x: any) => x !== event)
    )
  }



  isNumberKey(evt: KeyboardEvent) {
    const currencyFormat = /^\d*\.?\d*$/;
    if (currencyFormat.test(evt.key) !== true) {
      return false;
    }
    return true;
  }


  addCoveredItem() {
    if (this.coveredItemForm.valid) { 
      if (this.imagestoupload) {
        const data = new FormData();

        Object.keys(this.coveredItemForm.value).forEach(fieldName => {
          if (this.coveredItemForm.value[fieldName]) {
            data.append(fieldName, fieldName === 'image' ? this.coveredItemForm.value[fieldName] : this.coveredItemForm.value[fieldName].toString());
          }
        });
        if(!this.isSelectedOptionalItem) {
          data.delete('coveredPlanIds');
          data.delete('allowedMultipleItem');
        }

        const apiUrl = this.coveredItemId ? endpoints.planManagement.coverItem.updateCoverItem(this.coveredItemId) : endpoints.planManagement.coverItem.createCoverItem;
        this.apiservice.postMultiData(apiUrl, data).pipe(takeUntil(this.ngUnsubscribe)).subscribe((res: any) => {
          if (res.body) {
            this.apiservice.alert(res.body.message, ErrorType.Success);
            this.location.back();
          } else {
            this.apiservice.alert(res.body.message, ErrorType.Warning);
          }
        }, err => {
          if (err) {
            Object.keys(err.errors).map((error) => {
              this.apiservice.alert(err.errors[error], ErrorType.Error);
            })
          }
        });
      } else {
        this.apiservice.alert(ErrorText.PleaseUploadTheImage, ErrorType.Error);
      }
    } else {
      this.coveredItemForm.markAllAsTouched();
      const firstInvalidControl: HTMLElement = this.el.nativeElement.querySelector("input.ng-invalid");
      const textAreaInvalidControl: HTMLElement = this.el.nativeElement.querySelector("textarea.ng-invalid");
      if(firstInvalidControl){firstInvalidControl.focus()} //without smooth behavior
      if(!firstInvalidControl && textAreaInvalidControl){textAreaInvalidControl.focus()} //without smooth behavior
    }
  }
  onImageUpload(event: any) {    
    if (event.target.files[0].type === 'image/jpeg' || event.target.files[0].type === 'image/png' || event.target.files[0].type === 'image/jpg') {
      let file;
      file = event.target.files[0];
      this.coveredItemForm.patchValue({ image: file });
      const reader = new FileReader();
      reader.onload = (e: any) => {
        this.imagestoupload = e.target.result;
      };
      reader.readAsDataURL(event.target.files[0]);
    } else {
      this.apiservice.alert(ErrorText.ImageRestriction, 'error');
    }
  }
  getMainFourPlanOptionalItem(){
    this.apiservice.get(endpoints.planManagement.coverItem.getMainFourPlanOptionalItem).pipe(takeUntil(this.ngUnsubscribe)).subscribe({
      next: (res: HttpResponse<any>) => {
        if(res.body){
          this.planOptionalItemCategories = res.body?.planOptionalItemCategories || [];
          if(this.coveredItemId){
            this.getCoveredItemDetails(this.coveredItemId);
          }
        }
      },
      error: (err: HttpErrorResponse) => {
        this.apiservice.alert(err.message, ErrorType.Error);
      }
    })
  }
  onPlanTypeChange(value: any) {
   this.isSelectedOptionalItem = this.checkOptionalItemExistOrNot(value, 'optional item');
   this.validateCoveredPlanIdsField(this.isSelectedOptionalItem);
  }
  checkOptionalItemExistOrNot(values: string[], itemName: string): boolean {
    const valueSet = new Set(values);
    return this.planOptionalItemCategories.some((item) => {
      return (
        valueSet.has(item?.planOptionalItemCategoryId) &&
        item?.title?.toLowerCase().includes(itemName.toLowerCase())
      );
    });
  }
  getAllOptionalItemCategories() {
    this.apiservice
      .get(
        `${endpoints.planManagement.planPrice.getOptionalItems}?page=1&size=100&type=main`
      )
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe({
        next: (res: HttpResponse<any>) => {
          if (res.body) {
            this.optionalItem = res.body?.planOptionalItemCategories?.data;
          }
        },
        error: (err: HttpErrorResponse) => {
          this.apiservice.alert(err.message, ErrorType.Error);
        },
      });
  }
  validateCoveredPlanIdsField(isRequired: boolean) {
    const coveredPlanIdsControl = this.coveredItemForm.get('coveredPlanIds');
    if (isRequired) {
      coveredPlanIdsControl?.setValidators([Validators.required]);
    } else {
      coveredPlanIdsControl?.clearValidators();
    }
    coveredPlanIdsControl?.updateValueAndValidity();
  }
  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
